module.exports = __webpack_public_path__ + "static/media/Rectangle.b484e67e.png";